/* Love Bubble BUILD helpers: zero-pad the native countdown digits (mockup shows 05, 09, ...) */
(function () {
  function pad(el) {
    var v = (el.textContent || '').trim();
    if (v.length === 1 && v >= '0' && v <= '9') el.textContent = '0' + v;
  }
  function hook() {
    var els = document.querySelectorAll(
      '[data-countdown-timer] [data-days],[data-countdown-timer] [data-hours],[data-countdown-timer] [data-minutes],[data-countdown-timer] [data-seconds]'
    );
    els.forEach(function (el) {
      pad(el);
      new MutationObserver(function () { pad(el); }).observe(el, { childList: true, characterData: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hook);
  } else {
    hook();
  }
})();
